import { LanguageCode } from '../core';
import { Voice } from './voice';

export enum VoiceDefaultChannel {
  default = 'default'
}

export type VoiceChannel = Voice | VoiceDefaultChannel;

export type DesignModuleNodeConfigChannelMultivoice = Partial<Record<VoiceChannel, string>>;

export type DesignModuleNodeConfigChannelValue = Partial<Record<LanguageCode, string | DesignModuleNodeConfigChannelMultivoice>>;
